var exports = {
  "X7": "UserProfileBadges.module__containerModal___VnQ1X2",
  "j4": "UserProfileBadges.module__containerModalMobile___VnQ1X2",
  "pP": "UserProfileBadges.module__containerModalDesktop___VnQ1X2",
  "RS": "UserProfileBadges.module__containerPopout___VnQ1X2",
  "Qk": "UserProfileBadges.module__badgeMobile___VnQ1X2",
  "EJ": "UserProfileBadges.module__badgeDesktop___VnQ1X2",
  "X8": "UserProfileBadges.module__sequenceBadge___VnQ1X2",
  "Fi": "UserProfileBadges.module__sequenceBadgeMobile___VnQ1X2",
  "Hd": "UserProfileBadges.module__sequenceBadgeDesktop___VnQ1X2",
  "nf": "UserProfileBadges.module__link___VnQ1X2",
  "$J": "UserProfileBadges.module__linkButton___VnQ1X2",
};

module.exports = exports;
